import React, { Component } from "react";
import {
  toFixed,
  GET,
  loading,
  Status,
  Pagination,
  Navbar,
} from "../../components/CustomComponent.js";
import RANK1 from "../../assets/images/rank/rank2.png";
import RANK2 from "../../assets/images/rank/rank3.png";
import RANK3 from "../../assets/images/rank/rank4.png";
export default class Brokers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_currency: "THB",

      data: [],
      loaded: false,
      count: 10,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let data, count;
    let [result] = await Promise.all([
      GET("v1/admin/brokers", {
        page_size: 10,
        page: page,
        data_search: this.state.filter_search,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result?.pagination?.count;
    }
    this.setState({
      data,
      loaded: true,
      count,
    });
    loading(false);
  };
  render() {
    const { filter_search, filter_currency, data, loaded, count } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
<div>
              <div className="ar-eyebrow mb-1">Agent</div>
              <h2 className="ar-title mb-1">Broker Management</h2>
              <div className="ar-subtitle">Manage broker accounts and financial overview</div>
            </div>
            </div>
<div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                <span className="ar-filter-label">Search</span>
                <input
                  type="text"
                  className="form-control pr-input"
                  placeholder="Search..."
                  onChange={(e) => {
                    this.setState({ filter_search: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_search}
                />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState({ filter_search: "" }, () => this.Get(1))
                  }
                >
                  Reset
                </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf1ad"}</span>
                  Brokers
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">Broker accounts and financial overview</div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="wpx-50 text-center">Tier</td>
                    <td className="text-nowrap">Broker</td>
                    <td className="text-nowrap">Deposits</td>
                    <td className="text-nowrap">Withdrawals</td>
                    <td className="text-end text-nowrap">Balance</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="Tier" className="text-center">
                        <img
                          className="pointer"
                          alt={item.tier?.tier_name || ""}
                          src={
                            item.tier?.tier_name?.includes("1")
                              ? RANK1
                              : item.tier?.tier_name?.includes("2")
                              ? RANK2
                              : item.tier?.tier_name?.includes("3")
                              ? RANK3
                              : ""
                          }
                          width={20}
                          title={item.tier?.tier_name || ""}
                        />
                      </td>
                      <td data-label="Broker" className="text-nowrap">
                        {item.name_en || item.name_th || "-"}
                      </td>
                      <td data-label="Deposits" className="text-nowrap py-1">
                        <div>
                          <div style={{ height: 14 }}>
                            {toFixed(
                              item.gateway_active?.find(
                                (e) => e.currency === filter_currency
                              )?.total_deposits || 0,
                              2
                            ) || "0.00"}
                          </div>
                          <small
                            className={
                              item.gateway_active?.find(
                                (e) => e.currency === filter_currency
                              )?.order_deposits
                                ? "text-primary"
                                : "text-secondary"
                            }
                          >
                            {item.gateway_active?.find(
                              (e) => e.currency === filter_currency
                            )?.order_deposits || 0}{" "}
                            orders
                          </small>
                        </div>
                      </td>
                      <td data-label="Withdrawals" className="text-nowrap py-1">
                        <div>
                          <div style={{ height: 14 }}>
                            {toFixed(
                              item.gateway_active?.find(
                                (e) => e.currency === filter_currency
                              )?.total_withdrawals || 0,
                              2
                            ) || "0.00"}
                          </div>
                          <small
                            className={
                              item.gateway_active?.find(
                                (e) => e.currency === filter_currency
                              )?.order_withdrawals
                                ? "text-primary"
                                : "text-secondary"
                            }
                          >
                            {item.gateway_active?.find(
                              (e) => e.currency === filter_currency
                            )?.order_withdrawals || 0}{" "}
                            orders
                          </small>
                        </div>
                      </td>
                      <td data-label="Balance" className="text-end text-nowrap">
                        {item.wallets?.find(
                          (e) => e.currency === filter_currency
                        )?.balance
                          ? toFixed(
                              item.wallets?.find(
                                (e) => e.currency === filter_currency
                              )?.balance,
                              2
                            )
                          : "0.00"}
                      </td>
                      <td
                        data-label="Status"
                        className="text-nowrap text-center"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {item.is_active
                            ? Status("ACTIVE", "success")
                            : Status("INACTIVE", "danger")}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={6}
                        className="text-center text-secondary py-4"
                      >
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
